import { signInHref } from "@nexxt/account-ui";
import { frontrowClient } from "@nexxt/api-client/frontrow";
import { createQueryClient } from "@nexxt/app-kit";
import type { QueryClient } from "@tanstack/react-query";

let signingIn = false;

/** No session, or it expired or was revoked: the sign-in page, then back to the same page. */
function signIn(): void {
  if (signingIn) return;
  signingIn = true;
  // a full load: nothing of the previous user stays in memory
  location.assign(signInHref(`${location.pathname}${location.search}`));
}

/** The client of the signed-in pages: a 401 is a session that ended. */
export const { api, auth } = frontrowClient({ onUnauthenticated: signIn });

/**
 * The client of the sign-in pages and of the public ones (the e-TAF from its link, ADR-175, ADR-218): a 401 there is a
 * refused credential, answered on the page, not a session that ended.
 */
export const { auth: signInAuth, api: publicApi } = frontrowClient();

export const queryClient: QueryClient = createQueryClient();
